import { useParams } from "react-router";

export function useRequiredParams<T extends Record<string, unknown>>(): T {
  return useParams() as T;
}
